export default {
    home_page_title: "Account Data",
    security_page_title: "Veiligheidscentrum",
    security_setting_page_title: "Veiligheidscentrum",
    security_phone_label: "Telefoon",
    security_email_label: "E-mailadres",
    security_question_label: "Veiligheidsvraag",
    security_unset_text: "Nog niet resetten",
    security_setted_text: "Ingesteld",
    security_question_options: [
        "Wat is de naam van je moeder?",
        "Wat is de geboortedag van je echtgenoot/echtgenote?",
        "Wat is de naam van je vader?",
        "Wat is je studentnummer?",
        "Wat is de naam van je beste vriend van vroeger",
        "Wat is de naam van de persoon die het meest voor je betekent?"
    ],
    password_lost_page_title: "Paswoord vergeet",
    password_reset_page_title: "Wachtwoord resetten",
    password_lost_account_placeholder:
        "Voer de accountnaam in waarvan u het wachtwoord bent vergeten",
    empty_lost_account_tips: "Voer gebruikersnaam in",
    iscorrect_lost_account_tips: "Gebruiker bestaat niet",
    password_reset_new_placeholder: "Nieuw paswoord",
    password_reset_confirm_placeholder: "Bevestig nieuw paswoord",
    password_verify_page_title: "Identiteit verifiëren",
    phone_verify_page_title: "Identiteit verifiëren",
    email_verify_page_title: "Identiteit verifiëren",
    question_verify_page_title: "Identiteit verifiëren",
    phone_reset_page_title: "Telefoon",
    email_reset_page_title: "E-mailadres",
    question_reset_page_title: "Veiligheidsvraag",
    phone_binding_text: "Uw gebonden telefoonnummer:",
    email_binding_text: "Uw gebonden emailadres:",
    verification_code_text: "Verificatiecode",
    resend_text: "Verzend opnieuw",
    empty_phone_number_tips: "Vul Telefoon in",
    iscorrect_phone_number_tips: "Vul juiste teleffon",
    empty_verification_code_tips: "Vul Verificatiecode in",
    iscorrect_verification_code_tips: "Verificatiecode fout",
    password_placeholder: "Wachtwoord",
    empty_password_tips: "Voer paswoord in",
    iscorrect_password_tips: "Onjuist wachtwoord",
    mismatched_rule_password_tips:
        "Het wachtwoord kan geen &, #, spatie bevatten.",
    different_confirm_password_tips:
        "De ingevulde paswoorden komen niet overeen",
    empty_email_tips: "Voer emailadres in",
    iscorrect_email_tips: "Onjuist emailadres",
    answer_placeholder: "Antwoord",
    empty_question_tips: "Kies Beveiligingsvraag",
    empty_answer_tips: "Voer antwoord in,",
    iscorrect_answer_tips: "Antwoord niet juist",
    next_step_text: "Volgend",
    submit_text: "Indienen",
    submit_success_tips: "Ingesteld",
    submit_error_tips: "De bewerking is mislukt, probeer het opnieuw",
    get_data_fail_tips: "Netwerkprobleem gedetecteerd, probeer het later weer",
    use_other_verification_type_text: "Alternatieve verificatie",
    custom_support_notice:
        "De account heeft nog geen veiligheidsinformatie ingesteld, open de link hieronder via uw PC om te verifiëren" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
